/* eslint-disable max-len */
/* eslint class-methods-use-this: ["error", { "exceptMethods": ["handleSuccess", "handleError", "redirectTo"] }]  */
import axios from 'axios'
import { HttpRequest, HttpResponse } from '../../../data/protocols/http/http-client'

export class AxiosHttpClient {
  api: any

  constructor(private readonly baseUrl: string | undefined) {
    const api = axios
    // api.interceptors.response.use(this.handleSuccess, this.handleError)
    this.api = api
  }

  async request({
    headers, method, url, data, params,
  }: HttpRequest): Promise<HttpResponse> {
    let axiosResponse

    try {
      axiosResponse = await this.api.request({
        url: this.baseUrl + url,
        method,
        data,
        headers: {
          ...headers,
        },
        params,
      })
    } catch (error: any) {
      axiosResponse = error.response
    }

    return {
      statusCode: axiosResponse.status,
      body: axiosResponse.data,
    }
  }

  handleSuccess = (response: any): object => response

  handleError = (error: { response: { status: any } }): Promise<object> => {
    const { status } = error.response
    switch (status) {
      case 401:
        this.redirectTo(document, '/sair')
        break
      case 403:
        this.redirectTo(document, '/403')
        break
      case 404:
        this.redirectTo(document, '/404')
        break
      default:
        this.redirectTo(document, '/404')
    }
    return Promise.reject(error)
  }

  redirectTo = (document: { location: object }, path: any): void => {
    // eslint-disable-next-line no-param-reassign
    document.location = path
  }
}
